import { render, staticRenderFns } from "./bread-crumbs.vue?vue&type=template&id=4cbe69ce"
import script from "./bread-crumbs.vue?vue&type=script&lang=js"
export * from "./bread-crumbs.vue?vue&type=script&lang=js"
import style0 from "./bread-crumbs.vue?vue&type=style&index=0&id=4cbe69ce&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports